/**
 * Select field formatters
 * Uses loose equality (==) to handle string/number comparison
 */

/**
 * Creates a display formatter for select fields
 * @param {Array} options - Array of {value, label} options
 * @returns {Function} Formatter function
 */
export function createSelectDisplayFormatter(options) {
  return (value) => {
    if (value == null) return '-';
    const option = options.find(o => o.value == value);
    return option ? option.label : '-';
  };
}

/**
 * Creates a standard EXIF formatter for select fields (converts to integer)
 * @param {*} fallbackValue - Value to use if input is null/undefined
 * @returns {Function} Formatter function
 */
export function createSelectExifFormatter(fallbackValue = null) {
  return (value) => value !== null && value !== undefined ? parseInt(value) : fallbackValue;
}

/**
 * Returns standard select field formatters
 * @param {Array} options - Array of {value, label} options
 * @param {Object} options - Configuration options
 */
export function getSelectFormatters(selectOptions, config = {}) {
  const { defaultValue = null, fallbackValue = null } = config;
  return {
    options: selectOptions,
    formatForDisplay: createSelectDisplayFormatter(selectOptions),
    formatForExif: createSelectExifFormatter(fallbackValue),
    formatFromExif: (value) => value || defaultValue,
    defaultValue
  };
}
